<template>
  <div ref="chart" style="width: 100%; height: 200px"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "AreaChart",
  props: {
    chartData: {
      type: Array,
      required: true,
    },

    xAxisData: {
      type: Array,
      required: true,
    },
    areaColor: {
      type: String,
      default: "#5470C6",
    },
  },
  data() {
    return {
      chartInstance: null,
    };
  },
  mounted() {
    this.initChart();
  },
  watch: {
    chartData: {
      handler() {
        this.updateChart();
      },
      deep: true,
    },
    xAxisData: {
      handler() {
        this.updateChart();
      },
      deep: true,
    },
  },
  methods: {
    initChart() {
      this.chartInstance = echarts.init(this.$refs.chart);
      this.updateChart();
    },
    updateChart() {
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
          },
        },
        grid: {
          left: "2%",
          bottom: "5%",
          top: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xAxisData,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "数值",
            type: "line",
            stack: "总量",
            areaStyle: {
              color: this.areaColor,
            },
            data: this.chartData,
          },
        ],
      };

      this.chartInstance.setOption(option);
    },
  },
  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },
};
</script>

<style scoped>
/* 你可以在这里添加一些样式 */
</style>
